import { BpkButtonV2 } from '@skyscanner/backpack-web/bpk-component-button';
import {
  withButtonAlignment,
  withRtlSupport,
} from '@skyscanner/backpack-web/bpk-component-icon';
import ArrowRight from '@skyscanner/backpack-web/bpk-component-icon/sm/long-arrow-right';

import constants from '../constants';
import buildUrl from '../helpers/url-builder';
import { trackSelectExploreAll } from '../services/event-tracking';
import withStrings from '../withStrings';

import type { ExploreAllDestinationsButtonProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

import STYLES from './BrowseList.module.scss';

const {
  STRINGS: { SEE_MORE_DESTINATIONS },
} = constants;

const LongArrowRight = withButtonAlignment(withRtlSupport(ArrowRight));

const exploreAll = async (
  e: Event,
  browseUrl: string,
  query: { destination: string; origin: string },
) => {
  e.preventDefault();

  await trackSelectExploreAll(query);
  window.location.href = browseUrl;
};

const ExploreAllDestinationsButton = ({
  query,
  strings,
}: ExploreAllDestinationsButtonProps) => {
  const context = {
    originId: query.origin,
    destinationId: query.destination,
    tripType: 'return',
    outboundDate: 'wholeyear',
    inboundDate: 'wholeyear',
  };

  const browseUrl = buildUrl(strings, context);

  return (
    <div className={STYLES.ExploreButton__navigationButton}>
      <BpkButtonV2
        href={browseUrl}
        onClick={(e: Event) => exploreAll(e, browseUrl, query)}
        rel="nofollow"
        implicit
      >
        {strings[SEE_MORE_DESTINATIONS]}
        <div className={STYLES.ExploreButton__chevronArrow}>
          <LongArrowRight />
        </div>
      </BpkButtonV2>
    </div>
  );
};

export default withStrings(ExploreAllDestinationsButton);
